import { render, staticRenderFns } from "./ourHotel.vue?vue&type=template&id=4c6f2b00"
import script from "./ourHotel.vue?vue&type=script&lang=js"
export * from "./ourHotel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports